/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PatternMatchType = {
    MustMatch: 'must_match',
    MustNotMatch: 'must_not_match'
} as const;
export type PatternMatchType = typeof PatternMatchType[keyof typeof PatternMatchType];


export function instanceOfPatternMatchType(value: any): boolean {
    for (const key in PatternMatchType) {
        if (Object.prototype.hasOwnProperty.call(PatternMatchType, key)) {
            if (PatternMatchType[key as keyof typeof PatternMatchType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PatternMatchTypeFromJSON(json: any): PatternMatchType {
    return PatternMatchTypeFromJSONTyped(json, false);
}

export function PatternMatchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatternMatchType {
    return json as PatternMatchType;
}

export function PatternMatchTypeToJSON(value?: PatternMatchType | null): any {
    return value as any;
}

export function PatternMatchTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PatternMatchType {
    return value as PatternMatchType;
}

